module.exports = __webpack_public_path__ + "static/logo-jet2holidays.1a90f9cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-jet2holidays.png
// module id = 411
// module chunks = 114276838955818